import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ByocMissionDirective } from './mission.directive';

@NgModule({
    declarations: [ByocMissionDirective],
    imports: [CommonModule],
    exports: [ByocMissionDirective],
})
export class DirectiveMissionModule {}
